import * as React from 'react';
import Select from 'antd/lib/select';
import { CommonProps } from './common.intefaces';
import { CargoTypes } from 'src/Library/Constants';

interface IProps extends CommonProps {
  cargoTypes: CargoTypes;
}

const SelectCargo = (props: IProps) => {

  const {
    mode,
    style,
    value,
    onChange,
    disabled,
    className,
    placeholder,
    cargoTypes,
  } = props;

  const renderCargoOptions = () => {
    return Object.keys(cargoTypes)?.map((item) => {
      return <Select.Option
        key={item}
      >
        {cargoTypes[item]}
      </Select.Option>;
    }) || [];
  };

  return <Select
    style={{
      ...(style || {}),
    }}
    allowClear
    showSearch
    value={value}
    disabled={disabled}
    onChange={onChange}
    className={className}
    mode={mode || 'default'}
    placeholder={placeholder || 'Select Cargo'}
    getPopupContainer={(trigger: any) => trigger.parentNode}
  >
    {renderCargoOptions()}
  </Select>;
};

export default React.memo(SelectCargo);
